import {
  brandEntityId,
  BrandEntityId,
  brandLogoDataFile,
  BrandLogoDataFile,
  brandLogoDataHeight,
  BrandLogoDataHeight,
  brandLogoDataWidth,
  BrandLogoDataWidth,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoCreate2VO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoCreate2VO.validationSchema()
  );

  constructor(readonly value: RoomBrandLogoCreate2) {
    JsonSchemaValidator.assert(RoomBrandLogoCreate2VO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "data", "width", "height"],
      properties: {
        roomId,
        brandId: brandEntityId,
        data: brandLogoDataFile,
        width: brandLogoDataWidth,
        height: brandLogoDataHeight
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandLogoCreate2 {
  roomId: RoomId;
  brandId: BrandEntityId;
  data: BrandLogoDataFile;
  width: BrandLogoDataWidth;
  height: BrandLogoDataHeight;
}
